import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div(({ theme }) => {
  const { color } = theme;

  return `
    border-radius: 8px;
    padding: 16px;
    border: 1px solid ${color.grayscale[800]};
    color: ${color.grayscale[800]};
    display: flex;
    flex-flow: column nowrap;
  `;
});

const ImageWrapper = styled.div`
  max-width: 44%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
`;

const Img = styled.img`
  display: block;
  margin: 16px;
`;

const Row = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  text-align: center;
  flex-grow: 1;

  @media screen and (min-width: 1280px) {
    text-align: left;
  }
`;

const SmallText = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.tiny};
    color: ${color.grayscale[0]} 
  `;
});

const LargeText = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.small};
    font-weight: ${type.weight.bold};
    color: ${color.grayscale[0]};

    @media screen and (min-width: 1280px) {
      font-size: ${type.size.regular};
    }
  `;
});

const Button = styled.button(({ theme }) => {
  const { color, type } = theme;

  return `
    border-radius: 73px;
    color: ${color.grayscale['0']};
    padding: 4px 12px;
    background: ${color.accentPrimary.light};
    font-size: ${type.size.tiny};
    margin: 1rem auto 0;
    display: inline-block;

    @media screen and (min-width: 1280px) {
      margin: 0 auto;
    }
  `;
});

export interface ICell {
  smallText: string;
  largeText: string;
  icon: string | false;
  button?: {
    text: string;
    callback: () => void;
  };
  type: string;
}

const Cell: FC<ICell> = ({ smallText, largeText, icon, button, type }) => {
  const [iconPath, setIconPath] = useState('');

  useEffect(() => {
    let icon;
    if (icon && iconPath === '') {
      if (type === 'game') {
        icon = new URL(`../../../static/assets/game_icons/${icon}`, import.meta.url).href;
      } else {
        icon = new URL(`../../assets/icons/functional-skills/${icon}`, import.meta.url).href;
      }

      setIconPath(icon);
    }
  });

  return (
    <Container>
      <Row>
        {icon && (
          <ImageWrapper>
            <Img src={iconPath} alt="" />
          </ImageWrapper>
        )}

        <TextWrapper>
          <SmallText>{smallText}</SmallText>
          <LargeText>{largeText}</LargeText>
        </TextWrapper>
      </Row>

      {button && (
        <Row>
          <Button type="button" onClick={button.callback}>
            {button.text}
          </Button>
        </Row>
      )}
    </Container>
  );
};

export default Cell;
